import {GvfService} from "../../../gvf/js/gvf-service";
import {GvfUiService} from "../../../gvf/js/gvf-ui-service";
import {ObjectService} from "../../js/object-service";
import {FormField} from "../form-field/form-field";

export class FormFieldRichEditor extends FormField{
    constructor(scope,$root){
        super(scope,$root);
    }

    createTinyMCEOptions(){
        const isReadonly = this.$input.attr("readonly");
        const opc =
            {
                "target": this.$input.get(0),
                "body_class": "web-gvml",
                "statusbar": false,
                "menubar": false,
                "language": "es",
                "language_url": "/nodemdls/tinymce-i18n/langs/es.js",
                "content_css": "/css/web.min.css",
                "gecko_spellcheck": true,
                "plugins": "print,paste,searchreplace,advlist,charmap,lists,table",
                "entity_encoding": "named",
                "convert_urls": false,
                "force_p_newlines": true,
                "theme": "modern",
                "toolbar": "",
                "readonly": isReadonly?1:0,
                "setup": (ed) => {
                    ed.addButton("anchor",this.anchorButton(ed));
                    ed.addButton("link",this.linkButton(ed));
                    ed.addButton("title",this.titleButton(ed,""));
                    ed.addButton("subtitle",this.titleButton(ed,"sub"));
                    ed.addButton("newLine",this.newLineButton(ed));
                    ed.addButton("image",this.imageButton(ed));
                    ed.addButton("icon",this.iconButton(ed));
                    ed.addButton("video",this.videoButton(ed));
                    ed.on(
                        "change",
                        function(){
                            tinymce.triggerSave();
                        }
                    );
                }
            };

        if(!isReadonly){
            opc.toolbar = "bold underline italic icon | link unlink anchor | undo redo search replace pastetext | subscript superscript | charmap ";
            opc.valid_elements = "a[href|title],span[style|class],strong,em,sub,sup,br,img[src|class|width|height|title]";

            if(this.$root.data("editor-type")=="content"){
                opc.toolbar += " | title subtitle bullist numlist newLine | image video";
                opc.valid_elements += ",p,ul,ol,li,h1[class],h2[class],h3[class],h4[class],h5[class]";
            }else if(this.$root.data("editor-type")=="email"){
                opc.toolbar += " | title subtitle";
                opc.valid_elements += ",p,h1[class],h2[class],h3[class],h4[class],h5[class]";
            }else{
                opc.force_p_newlines = false;
                opc.forced_root_block = "";
            }
        }else{
            opc.toolbar = false;
            opc.menubar = false;
            opc.statusbar = false;
        }
        return opc;
    }

    newLineButton(ed){
        return {
            title: "Insertar salto de línea",
            onclick: ()=>{
                ed.selection.setContent(ed.selection.getContent({format: "raw"})+"<br />");
            }
        };
    }

    anchorButton(ed){
        return {
            title: "Insertar ancla",
            onclick: ()=>{
                swal({
                    title: "Insertar ancla",
                    type: "input",
                    showCancelButton: true,
                    closeOnConfirm: true,
                    inputPlaceholder: "Nombre del ancla",
                    inputValue: "Check"
                },(inputValue)=>{
                    if(inputValue===false){
                        return false;
                    }
                    if(inputValue===""){
                        swal.showInputError("El nombre no puede estar vacío");
                        return false;
                    }
                    ed.selection.setContent("<img class=\"anchor anchor"+inputValue+"\" title=\"#"+inputValue+"\" src=\"/img/cp/editor/anchor.gif\" />");
                    return true;
                });
            }
        };
    }

    linkButton(ed){
        return {
            title: "Enlazar el texto seleccionado",
            onclick: ()=>{
                const $modal = this.$root.find(this.scope+"__link-modal").clone().appendTo($("body"));
                GvfUiService.init($modal);
                let $sel = $(ed.selection.getNode());
                if($sel.attr("href")){
                    $modal.find(".js-form-field[data-name=link]").formFieldSetVal(atob($sel.attr("href")));
                }else{
                    $sel = null;
                }
                $modal.modal("show");
                $modal.find(this.scope+"__save-link").click(
                    function(ev){
                        $modal.modal("hide");
                        const linkVal = $modal.find("[name=link]").val();
                        if(linkVal){
                            GvfService.endpoint(
                                "/web/web/get-link-description",
                                {link: linkVal}
                            ).then(
                                (resp) => {
                                    if($sel){
                                        $sel.attr("href",resp.base64);
                                        $sel.attr("title",resp.description);
                                    }else{
                                        const selectedText = ed.selection.getContent({format: "raw"});
                                        ed.selection.setContent("<a href=\""+resp.base64+"\" title=\""+resp.description+"\">"+(selectedText?selectedText:"Link")+"</a>");
                                    }
                                    ed.save();
                                }
                            );
                        }else{
                            if($sel && $sel.is("a")){ //remove link
                                $sel.replaceWith($sel.text());
                            }
                        }
                    }
                );
            }
        };
    }

    insertMultimediaElement(ed,fileTypeId,alignment){
        const service = new ObjectService("RepFile");
        service.selectModelItem(
            {
                fieldData: {"t": 1}
            }
        ).then(
            (id)=>{
                const fInsertElement = (align) => {
                    if(fileTypeId==2){ //video
                        let size = "";
                        if(align!="full"){
                            size = " width='280' height='192'";
                        }
                        const img = "<img src=\"/img/cp/editor/video-placeholder.jpg\" class=\"vid vid"+id+" "+align+"\""+size+" />";
                        ed.selection.setContent(img);
                        ed.save();
                    }else{
                        GvfService.endpoint(
                            "/cp/rep-file-version/get-image-url-by-alignment",
                            {fileId: id,alignment: align}
                        ).then(
                            (resp) => {
                                const img = "<img src=\""+resp.url+"\" class=\"img img"+id+" "+align+"\" />";
                                ed.selection.setContent(img);
                                ed.save();
                            }
                        );
                    }
                };

                if(!alignment){
                    const $modal = this.$root.find(this.scope+"__align-modal").clone().appendTo($("body"));
                    $modal.modal("show");
                    $modal.find(this.scope+"__align-modal-link").click(
                        (ev) => {
                            $modal.modal("hide");
                            fInsertElement($(ev.currentTarget).data("value"));
                        }
                    );
                }else{
                    fInsertElement(alignment);
                }
            }
        );
    }

    imageButton(ed,alignment){
        return {
            title: "Insertar una imagen",
            onclick: () => {
                this.insertMultimediaElement(ed,1,alignment);
            }
        };
    }

    iconButton(ed){
        return {
            title: "Insertar un icono",
            onclick: () => {
                const service = new ObjectService("RepFile");
                service.selectModelItem(
                    {
                        fieldData: {"t": 1}
                    }
                ).then(
                    (id) => {
                        GvfService.endpoint(
                            "/cp/rep-file-version/get-image-url",
                            {fileId: id,extension: "png",width: 32,height: 32,resizeType: 1},
                            "get"
                        ).then(
                            (resp) => {
                                const img = "<img src=\""+resp.url+"\" class=\"img img"+id+" icon\" />";
                                ed.selection.setContent(img);
                                ed.save();
                            }
                        );
                    }
                );
            }
        };
    }

    videoButton(ed,alignment){
        return {
            title: "Insertar un video",
            onclick: () => {
                this.insertMultimediaElement(ed,2,alignment);
            }
        };
    }

    titleButton(ed,sub){
        return {
            title: "Insertar un "+sub+"título",
            onclick: ()=>{
                const $modal = this.$root.find(this.scope+"__title-modal").clone().appendTo($("body"));
                let $sel = $(ed.selection.getNode());
                if(!$sel.is("h1,h2,h3,h4,h5")){
                    $sel = null;
                }
                $modal.modal("show");
                $modal.find(this.scope+"__title-modal-link").click(
                    (ev) => {
                        $modal.modal("hide");
                        const selectedLevel = $(ev.currentTarget).data("level");
                        let txt = ed.selection.getContent({format: "text"});
                        if(txt.length==0){
                            txt = "Texto de título";
                        }
                        if($sel){
                            txt = $sel.text();
                        }
                        const html = "<h"+selectedLevel+" class=\"web-gvml__"+sub+"title\">"+txt+"</h"+selectedLevel+">";
                        if($sel){
                            $sel.replaceWith(html);
                        }else{
                            ed.selection.setContent(html);
                        }
                        ed.save();
                    }
                );
            }
        };
    }

    getVal(){
        return tinymce.get(this.$input.attr("id")).getContent({format: "raw"});
    }

    setVal(val,noEvent){
        const setFunction = () => {
            const editorObject = tinymce.get(this.$input.attr("id"));
            if(editorObject){
                editorObject.setContent(val);
                this.$input.val(val);
                if(!noEvent){
                    this.$root.trigger("formField:changeVal");
                }
            }
        };

        //protect from uninitialized tinymce
        if(window.tinymce){
            const editorObject = tinymce.get(this.$input.attr("id"));
            if(editorObject){ //available editor
                setFunction();
                return;
            }
        }

        //no tiny or no instance: wait
        setTimeout(setFunction,1000);
    }

    ready(){
        super.ready();
        this.$input = this.$root.find("textarea");

        if(this.$input.attr("rows")>0){
            this.$input.css("height",this.$input.attr("rows")+"em");
        }

        import("tinymce").then(
            ({default:tinymce}) => {
                setTimeout(
                    () => {
                        tinymce.baseURL = "/nodemdls/tinymce";
                        tinymce.init(this.createTinyMCEOptions());
                    },
                    500
                );
            }
        );
    }
}

